
import { Vue, Component } from "vue-property-decorator"
import AdminUsers from "@/views/AdminUsers.vue"

@Component({
  components: { AdminUsers },
})
export default class Editors extends Vue {}
